interface ClosestTarget extends EventTarget {
  closest(selector: string): Element | null;
}

function supportsClosest(target: EventTarget | null): target is ClosestTarget {
  return Boolean(target && "closest" in target && typeof target.closest === "function");
}

/** Menu feedback belongs to menus, not to gameplay controls layered over the scene. */
export function shouldPlayMenuButtonSound(target: EventTarget | null): boolean {
  if (!supportsClosest(target)) return false;
  const button = target.closest("button");
  return Boolean(button && !button.closest(".mobile-controls"));
}
